import classnames from 'classnames/bind'
import React from 'react'

import Quote, { QuoteProps } from '~/components/Quote'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface QuotesProps {
  className?: string
  items?: QuoteProps[]
  layout?: 'normal' | 'centered'
}
/**
 * Quotes slice
 * @param props
 * @returns Slice
 */
function Quotes({ className, items, layout = 'centered' }: QuotesProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })

  const quotes = items?.map((item, index) => {
    return (
      <div key={`quote${index}`} className={css.quoteContainer}>
        <Quote className={css.quote} {...item} index={index} />
      </div>
    )
  })

  return (
    <section className={cx(className, css.Quotes, { [layout]: layout })}>
      <div className={cx(css.container)}>{quotes}</div>
    </section>
  )
}

Quotes.defaultProps = {}

export default Quotes
